/**
 * Promisified version of `setTimeout`.
 *
 * @param ms The number of milliseconds to wait before resolving the promise.
 */
export const delay = async (ms: number): Promise<void> => {
  await new Promise<void>(resolve => setTimeout(resolve, ms))
}
